import { render, staticRenderFns } from "./index.vue?vue&type=template&id=de2e193a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=de2e193a&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de2e193a')) {
      api.createRecord('de2e193a', component.options)
    } else {
      api.reload('de2e193a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=de2e193a", function () {
      api.rerender('de2e193a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/QuestionnaireSystem/components/CreateQuesTopic/components/QuestionTable/index.vue"
export default component.exports